import { api } from "./api";
import { dedupedFetch } from "./cache";

const fetchRule = async():Promise<any> =>{
    return dedupedFetch("rule", async () => {
        const query = [{
            $match:{}
        }]
        const {data} = await api.post('/database/regulation__c/aggregate',query)

        if(!Array.isArray(data)){
            return [];
        }else{
            return data[0];
        }
    }, 120_000);
}

const fetchRuleElbb = async():Promise<any> =>{
    return dedupedFetch("ruleElbb", async () => {
        const {data} = await api.get('/database/regulation_elbb__c')

        if(!Array.isArray(data)){
            return [];
        }else{
            return data[0];
        }
    }, 120_000);
}

export {
    fetchRule, fetchRuleElbb
}
